import Typography from '@mui/material/Typography';

export default function CirclesPage() {
  return (
    <Typography variant='large' fontSize={38}>
      Circles page
    </Typography>
  )
}